module.exports = __webpack_public_path__ + "static/media/crossbonds.1b4c8802.jpg";